import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'

export const rmaDiscardModal: CSSResult = css`
  /* Only the bottom is widened — padding-block takes two values — so the space
     between the body text and the buttons grows without moving the icon. */
  cse-modal {
    --cse-modal-body-padding-y: ${csSpacing.spacing06} ${csSpacing.spacing08};
  }
`
